import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftAlert from "components/SoftAlert";

// Soft UI Dashboard PRO React example components

import ApiService from "services/ApiService";
import ToastUtils from "utils/ToastUtils";
import _ from "lodash";
import ValidationService from "services/ValidationService";
import Helpers from "utils/Helpers";
import Input from "components/CustomFields/Input";

function UserUpdateForm() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [disabledPhoneVer, setDisabledPhoneVer] = useState(false);
  const [disabledEmailVer, setDisabledEmailVer] = useState(false);
  const [role, setRole] = useState(null);
  const [roleId, setRoleId] = useState(0);
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);

  const handleFirstName = (val) => {
    setFirstNameError(false);
    setFirstName(val);
  };

  const handleLastName = (val) => {
    setLastNameError(false);
    setLastName(val);
  };

  const handlePhone = (val) => {
    setPhoneError(false);
    setPhone(val);
  };

  const sendEmailVerification = async () => {
    setDisabledEmailVer(true);
    const response = await ApiService.getData(`/api/v1/users/send-email-verification`);
    if (!response) {
      ToastUtils.error("Αδυναμία αποστολής συνδέσμου!");
      setDisabledEmailVer(false);
    } else {
      ToastUtils.success("Επιτυχία αποστολής συνδέσμου!");
    }
  };

  const sendPhoneVerification = async () => {
    setDisabledPhoneVer(true);
    const response = await ApiService.getData(`/api/v1/users/send-phone-verification`);
    if (!response) {
      ToastUtils.error("Αδυναμία αποστολής συνδέσμου!");
      setDisabledPhoneVer(false);
    } else {
      ToastUtils.success("Επιτυχία αποστολής συνδέσμου!");
    }
  };

  const updateUser = async () => {
    const user = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: phone,
      disabled: false,
      roleId: roleId,
      emailVerified: disabledEmailVer,
      phoneVerified: disabledPhoneVer,
    };

    const error = ValidationService.validateFullUser(user);

    if (error) {
      console.error(error.message);
      const errorPath = _.get(error, "details[0].path[0]");
      if (errorPath == "firstName") setFirstNameError(true);
      if (errorPath == "lastName") setLastNameError(true);
      if (errorPath == "phone") setPhoneError(true);
      return;
    }

    const response = await ApiService.putData(`/api/v1/users/me`, user);
    if (!response) {
      ToastUtils.error(`Αδυναμία επεξεργασίας χρήστη!`);
      return;
    }

    ToastUtils.success("Επιτυχία επεξεργασίας χρήστη!");
    await Helpers.waitTimeout(2000);
  };

  const fetchUserData = async () => {
    const userData = await ApiService.getData(`/api/v1/users/me`);
    if (!userData) {
      ToastUtils.error("Αδυναμία εύρεσης δεδομένων χρήστη!");
      return;
    }

    setFirstName(_.get(userData.data, "firstName"));
    setLastName(_.get(userData.data, "lastName"));
    setEmail(_.get(userData.data, "email"));
    setPhone(_.get(userData.data, "phone"));
    setDisabledPhoneVer(userData.data.phoneVerified);
    setDisabledEmailVer(userData.data.emailVerified);
    setRole(userData.data.role.name);
    setRoleId(userData.data.role.id);
  };

  useState(() => {
    fetchUserData();
  }, []);

  return (
    <Grid item xs={12} lg={8}>
      <Card sx={{ overflow: "visible" }}>
        <SoftBox p={2} lineHeight={1}>
          <SoftTypography variant="h6" fontWeight="medium">
            Επεξεργασία στοιχείων χρήστη
          </SoftTypography>
          <SoftTypography variant="button" fontWeight="regular" color="text">
            Επεξεργαστείτε τα στοιχεία σας στην παρακάτω φόρμα.
          </SoftTypography>
          <Divider />
          <Grid container spacing={3}>
            <Input
              xs={12}
              md={4}
              handler={handleFirstName}
              initialValue={firstName}
              title="Όνομα"
              error={firstNameError}
            />
            <Input
              xs={12}
              md={4}
              handler={handleLastName}
              initialValue={lastName}
              title="Επίθετο"
              error={lastNameError}
            />
            <Input xs={12} md={4} initialValue={role} title="Ρόλος" disabled={true} />
          </Grid>
          <Grid container spacing={3}>
            <Input xs={12} md={8} initialValue={email} title="Email" disabled={true} />

            <Grid item xs={12} md={4}>
              <SoftBox
                display="flex"
                flexDirection="column"
                justifyContent="flex-end"
                height="100%"
              >
                <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Αποστολή συνδέσμου επαλήθευσης email
                  </SoftTypography>
                </SoftBox>
                <SoftButton
                  color="success"
                  onClick={sendEmailVerification}
                  disabled={disabledEmailVer}
                >
                  επαληθευση email
                </SoftButton>
              </SoftBox>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Input
              xs={12}
              md={8}
              initialValue={phone}
              title="Τηλέφωνο"
              handler={handlePhone}
              error={phoneError}
            />

            <Grid item xs={12} md={4}>
              <SoftBox
                display="flex"
                flexDirection="column"
                justifyContent="flex-end"
                height="100%"
              >
                <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Αποστολή συνδέσμου επαλήθευσης τηλεφώνου
                  </SoftTypography>
                </SoftBox>
                <SoftButton
                  color="success"
                  onClick={sendPhoneVerification}
                  disabled={disabledPhoneVer}
                >
                  επαληθευση τηλεφωνου
                </SoftButton>
              </SoftBox>
            </Grid>
          </Grid>

          <SoftBox display="flex" justifyContent="flex-end" mt={3}>
            <SoftButton
              variant="gradient"
              color="info"
              style={{ width: "100%" }}
              onClick={updateUser}
            >
              ΕΠΕΞΕΡΓΑΣΙΑ
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </Card>
    </Grid>
  );
}

export default UserUpdateForm;
